<template>
  <section class="unfinished home-section bg-gradient pd-both container" id="unfinished">
    <h2 class="row-title1 ph-text" v-if="loading">■■■■■■■■■■■■■■■■■■■■■■■■■■■</h2>
    <h2 class="row-title1" v-else>{{ $t("home.unfinished.title") }}</h2>
    <episode-list-detailed :episodes="unfinishedEpisodes" :loading="loading" :loading-item-count="3" />
    <div class="gallery-wp" v-if="!loading && unfinishedEpisodes && unfinishedEpisodes.length==0">
      <ul class="gallery-list list-with-divider no-bullet">
        <li class="justify-row">
          <div class="main-item" v-if="!currentUser._is_guest">
            <h3 class="h3">{{ $t("home.unfinished.none") }}</h3>
          </div>
          <div class="main-item" v-else>
            <h3 class="h3"><a class="js-newpage" href=""
              @click.prevent=""
            >{{ $t("home.unfinished.login_required") }}</a></h3>
            <div class="label"><a class="button--quiet button-small" href=""
              @click.prevent="navigatorPushLogin({allowPop: true})"
            >{{ $t("home.unfinished.login_now") }}</a></div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import EpisodeListDetailed from '../EpisodeListDetailed.vue';

export default {
  props: ['loading', 'unfinishedEpisodes'],

  components: {
    'episode-list-detailed': EpisodeListDetailed,
  },
};
</script>
